import { Component, OnInit } from '@angular/core';
import { MenuService } from 'app/services/menu.service'
import { CookieService } from 'ngx-cookie-service'

@Component({
  selector: 'app-retrainings',
  templateUrl: './retrainings.component.html',
  styleUrls: ['./retrainings.component.scss']
})
export class RetrainingsComponent implements OnInit {

  url

  constructor(private menuService: MenuService,
    private cookies: CookieService) {}

  ngOnInit() {
    this.url = this.menuService.getScreen('RETGS', true).url + this.cookies.get('at') + '&mode='+(localStorage.getItem('theme') == 'grey' ? 'light' : 'dark')
  }

}
